var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-display',{attrs:{"edit-path":_vm.editDialog,"max-width":_vm.maxWidth,"database-module":_vm.databaseModule,"display-name":_vm.displayName,"headers":_vm.headers},on:{"closeDialog":function($event){_vm.displayDialog = false}}})}
var staticRenderFns = []

export { render, staticRenderFns }